// gsap.registerPlugin(ScrollTrigger);
// const tl = gsap.timeline();

// // Homepage Hero Slider
// const heroSlide = document.querySelectorAll(".header-slider-desktop .swiper-slide");
// var heroSlider = new Swiper(".header-slider-desktop", {
//   loop: true,
//   watchSlidesProgress: true,
//   effect: "fade",
//   fadeEffect: {
//     crossFade: true,
//   },
//   autoplay: {
//     delay: 5000,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: ".slide-swiper-pagination",
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".hero-button-next",
//     prevEl: ".hero-button-prev",
//   },
//   on: {
//     init: function () {
//       var slideIndex = this.realIndex;
//       sliderInt(slideIndex);
//     },
//     slideChangeTransitionStart: function () {
//       var slideIndex = this.realIndex;
//       sliderInt(slideIndex);
//     },
//   }
// });

// function sliderInt(slideIndex) {
//   heroSlide.forEach((img) => {
//     const index = img.getAttribute("data-swiper-slide-index");
//     if (index == slideIndex) {
//       img.classList.add("activeBG");
//     } else {
//       img.classList.remove("activeBG");
//     }
//   });
//   gsap.from(
//     ".activeBG .target_animate",
//     0.4, {
//       y: 80,
//       opacity: 0,
//       clipPath: "inset(100% 0 0 0)",
//       stagger: {
//         amount: 0.4,
//       }
//     }
//   );
// }

// // play pause functionality for hero slider
// var playPauseBtn = document.getElementById('playPauseBtn');
// var isPlaying = true;

// playPauseBtn.addEventListener('click', function () {
//   var swiperContainer = document.querySelector('.header-slider-desktop');
//   swiperContainer.classList.toggle('toggled-class');

//   if (isPlaying) {
//     heroSlider.autoplay.stop();
//   } else {
//     heroSlider.autoplay.start();
//   }
//   isPlaying = !isPlaying;
// });

gsap.registerPlugin(ScrollTrigger);
const tl = gsap.timeline();

// Homepage Hero Slider
const heroSlide = document.querySelectorAll(".header-slider-desktop .swiper-slide");
const slideTransitionDuration = 500; // Set your desired transition duration in milliseconds
const slideChangeDelay = 5000; // Set the delay between slide changes in milliseconds

var heroSlider = new Swiper(".header-slider-desktop", {
  loop: true,
  watchSlidesProgress: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: slideTransitionDuration + slideChangeDelay,
    disableOnInteraction: true,
  },
  speed: slideTransitionDuration, // Set the transition speed
  pagination: {
    el: ".slide-swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".hero-button-next",
    prevEl: ".hero-button-prev",
  },
  on: {
    init: function () {
      var slideIndex = this.realIndex;
      sliderInt(slideIndex);
    },
    slideChangeTransitionStart: function () {
      var slideIndex = this.realIndex;
      sliderInt(slideIndex);
    },
  }
});

function sliderInt(slideIndex) {
  heroSlide.forEach((img) => {
    const index = img.getAttribute("data-swiper-slide-index");
    if (index == slideIndex) {
      img.classList.add("activeBG");
    } else {
      img.classList.remove("activeBG");
    }
  });

  // GSAP animation
  gsap.from(
    ".activeBG .target_animate",
    {
      duration: slideTransitionDuration / 1000, // Convert milliseconds to seconds
      y: 80,
      opacity: 0,
      clipPath: "inset(100% 0 0 0)",
      stagger: {
        amount: 0.4,
      }
    }
  );
}

// Play/pause functionality for hero slider
var playPauseBtn = document.getElementById('playPauseBtn');
var isPlaying = true;
var nextSlidePlay = false;
// var remainingTIme = 0;


playPauseBtn?.addEventListener('click', function () {
  var swiperContainer = document.querySelector('.header-slider-desktop');
  swiperContainer.classList.toggle('toggled-class');
  if (isPlaying) {
    // Stop autoplay and preserve the remaining delay time
    heroSlider.autoplay.pause();
  } else if(nextSlidePlay){
    nextSlidePlay = false;
    heroSlider.autoplay.start();
  } else {
    heroSlider.autoplay.resume();
  }
  isPlaying = !isPlaying;
  
});


// Pause autoplay when the tab is switched
document.addEventListener("visibilitychange", function() {
  if (document.visibilityState === 'hidden') {
    // Stop autoplay entirely
    heroSlider.autoplay.pause();
  } else {
    if (!isPlaying) {
      heroSlider.autoplay.resume();
    }
  }
});

// Listen for manual navigation (clicking next/prev buttons)
heroSlider.on('slideNextTransitionStart', function () {
  nextSlidePlay = true;
  if (!isPlaying) {
    heroSlider.autoplay.stop();
  } else {
    heroSlider.autoplay.start();
  }
});

heroSlider.on('slidePrevTransitionStart', function () {
  nextSlidePlay = true;
  if (!isPlaying) {
    heroSlider.autoplay.stop();
  } else {
    heroSlider.autoplay.start();
  }
});









// auto scroll image section
window.addEventListener('load', function () {
  if (window.innerWidth >= 768) {
    const races = document.querySelector(".auto_scroll_main");
    const progressBar = document.querySelector('.progress_inner');
    const containerWidth = document.querySelector('.progress-main').offsetWidth;

    function getScrollAmount() {
      let racesWidth = races.scrollWidth;
      return -(racesWidth - window.innerWidth);
    }
    const timeline = gsap.timeline();

    timeline.to(races, {
      x: getScrollAmount,
      ease: "none"
    });

    timeline.to('.progress_inner', {
      x: () => {
        return containerWidth - (195)
      },
      ease: "none"
    }, 0)

    ScrollTrigger.create({
      trigger: ".coll_pin_section",
      start: "top top",
      end: () => `+=${getScrollAmount() * -1}`,
      pin: true,
      animation: timeline,
      scrub: true,
      invalidateOnRefresh: true,
    });

    ScrollTrigger.observe({
      target: ".auto_scroll_container",
      type: "pointer,touch",

      onDrag: (self) => {
        gsap.to(window, {
          scrollTo: {
            y: `+=${self.deltaX * 10}`
          }
        });
      }
    });

    ScrollTrigger.addEventListener("refreshInit", getScrollAmount);
  }
});